export default __webpack_public_path__ + "static/media/8.b2710cb6.svg";